// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SettingsCard Component Styles */

.style_settingsCard__1L\\+8b {
  background-color: var(--table-row-white);
  border-radius: 12px;
  border: 1px solid var(--table-border);
  box-shadow: none;
  overflow: hidden;
  margin-bottom: 24px;
}

.style_cardHeader__5\\+3zO {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px;
  flex-direction: column;
  gap: 16px;
}

@media (min-width: 768px) {
  .style_cardHeader__5\\+3zO {
    padding: 24px 24px 16px 24px;
    align-items: center;
    flex-direction: row;
    gap: 0;
  }
}

.style_titleSection__Kv\\+mx {
  flex: 1 1;
  min-width: 0;
  width: 100%;
}

@media (min-width: 768px) {
  .style_titleSection__Kv\\+mx {
    width: auto;
  }
}

.style_titleRow__8uP-5 {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.style_title__Q-8-d {
  font-weight: 600;
  color: var(--text-heading);
  font-size: 1.1rem;
  line-height: 1.3;
}

@media (max-width: 500px) {
  .style_title__Q-8-d {
    font-size: 1rem;
  }
}

@media (min-width: 768px) {
  .style_title__Q-8-d {
    font-size: 1.25rem;
  }
}

.style_subtitle__eKWwt {
  color: var(--text-primary);
  margin-top: 4px;
  font-size: 0.875rem;
  line-height: 1.4;
}

.style_actionSection__nO9WK {
  display: flex;
  gap: 8px;
  width: 100%;
}

.style_actionSection__nO9WK > * {
  flex: 1 1;
  min-width: 0;
}

@media (min-width: 768px) {
  .style_actionSection__nO9WK {
    gap: 12px;
    width: auto;
  }
  
  .style_actionSection__nO9WK > * {
    flex: none;
    min-width: auto;
  }
}

.style_divider__O22kG {
  border-color: var(--table-border);
}

.style_cardContent__7H-yP {
  padding: 16px;
}

@media (min-width: 768px) {
  .style_cardContent__7H-yP {
    padding: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsCard/style.module.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,wCAAwC;EACxC,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;IACnB,MAAM;EACR;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* SettingsCard Component Styles */\n\n.settingsCard {\n  background-color: var(--table-row-white);\n  border-radius: 12px;\n  border: 1px solid var(--table-border);\n  box-shadow: none;\n  overflow: hidden;\n  margin-bottom: 24px;\n}\n\n.cardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 16px;\n  flex-direction: column;\n  gap: 16px;\n}\n\n@media (min-width: 768px) {\n  .cardHeader {\n    padding: 24px 24px 16px 24px;\n    align-items: center;\n    flex-direction: row;\n    gap: 0;\n  }\n}\n\n.titleSection {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n  .titleSection {\n    width: auto;\n  }\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.title {\n  font-weight: 600;\n  color: var(--text-heading);\n  font-size: 1.1rem;\n  line-height: 1.3;\n}\n\n@media (max-width: 500px) {\n  .title {\n    font-size: 1rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .title {\n    font-size: 1.25rem;\n  }\n}\n\n.subtitle {\n  color: var(--text-primary);\n  margin-top: 4px;\n  font-size: 0.875rem;\n  line-height: 1.4;\n}\n\n.actionSection {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n.actionSection > * {\n  flex: 1;\n  min-width: 0;\n}\n\n@media (min-width: 768px) {\n  .actionSection {\n    gap: 12px;\n    width: auto;\n  }\n  \n  .actionSection > * {\n    flex: none;\n    min-width: auto;\n  }\n}\n\n.divider {\n  border-color: var(--table-border);\n}\n\n.cardContent {\n  padding: 16px;\n}\n\n@media (min-width: 768px) {\n  .cardContent {\n    padding: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsCard": `style_settingsCard__1L+8b`,
	"cardHeader": `style_cardHeader__5+3zO`,
	"titleSection": `style_titleSection__Kv+mx`,
	"titleRow": `style_titleRow__8uP-5`,
	"title": `style_title__Q-8-d`,
	"subtitle": `style_subtitle__eKWwt`,
	"actionSection": `style_actionSection__nO9WK`,
	"divider": `style_divider__O22kG`,
	"cardContent": `style_cardContent__7H-yP`
};
export default ___CSS_LOADER_EXPORT___;
